import { render, staticRenderFns } from "./CourseFormModal.vue?vue&type=template&id=47cf02db&scoped=true"
import script from "./CourseFormModal.vue?vue&type=script&lang=js"
export * from "./CourseFormModal.vue?vue&type=script&lang=js"
import style0 from "./CourseFormModal.vue?vue&type=style&index=0&id=47cf02db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cf02db",
  null
  
)

export default component.exports